import React from 'react';
import DropdownMenu from '@components/DropdownMenu';
import UserIcon from '@assets/user-icon.svg';
import { useStyles } from './styles';

const AvatarMenu = ({
  initials,
  anchorEl,
  isDisplayInitials,
  handleLogout,
  handleOpenMenu,
  handleCloseMenu,
}) => {
  const classes = useStyles();

  return (
    <>
      <button className={classes.initialsBlock} onClick={handleOpenMenu}>
        {isDisplayInitials ? (
          <span className={classes.initialsText}>{initials}</span>
        ) : (
          <img className={classes.userImg} src={UserIcon} alt="user" />
        )}
      </button>
      <DropdownMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        handleLogout={handleLogout}
      />
    </>
  );
};

export default AvatarMenu;
